import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';
import Router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authTokens: {
      access: '',
      refresh: '',
    },
    user: {
      id: 0,
      name: '',
      company: {
        name: '',
        logo: null
      }
    },
    globalLoading: false,
    login: false,
    snack: {
      type: 'success',
      message: '',
      status: false,
      code: 0,
    },
    drawer: true,
    sorting: {
      status: {
        id: 0,
        name: "Все статусы"
      },
      priority: {
        id: 0,
        name: "Все приоритеты"
      },
      deadline: {
        status: false,
        date: ''
      },
      type: {
        name: 'Все типы',
        value: 0
      }
    }
  },
  mutations: {
    setSortType(state, object) {
      state.sorting.type = object;
    },
    setSortDeadline(state, object) {
      state.sorting.deadline = object;
    },
    setSortStatus(state, object) {
      state.sorting.status = object;
    },
    setPriorityStatus(state, object) {
      state.sorting.priority = object;
    },
    setAuthTokens(state, object) {
      state.authTokens.access = object.access;
      state.authTokens.refresh = object.refresh;
    },
    setUser(state, user) {
      state.user = user;
    },
    setLogin(state, status) {
      state.login = status;
    },
    setGlobalLoading(state, status) {
      state.globalLoading = status;
    },
    setUserLogin(state, data) {
      state.authTokens = {
        access: data.auth.access,
        refresh: data.auth.refresh
      };
      state.user = data.user;
      state.login = true;
    },
    setSnack(state, data) {
      state.snack = {
        status: data.status,
        code: data.code,
        message: data.message,
        type: data.type
      };
      if (data.code === 401) {
        this.dispatch('logout').then(r => window.console.log('logout dispatch from Store. ' +r ));
        Router.push({name: 'login'}).then(r => window.console.log('logout access error from Store. ' +r));
      }
    },
    drawerEnable(state, status) {
      state.drawer = status
    },
  },
  actions: {
    logout({ commit }) {
      commit('setAuthTokens', {
        authTokens: {
          access: '',
          refresh: '',
        },
      });
      commit('setUser', {
        user: {
          id: 0,
          name: '',
          company: {
            name: '',
            logo: 'no'
          }
        },
      });
      commit('setLogin', false);
      Router.push({name: 'login'}).then(r => window.console.log('logout access error from logout. ' +r));
    },
    hideSnack({ commit }) {
      commit('setSnack', {
        snack: {
          type: 'success',
          message: '',
          status: false
        }
      });
    },
    sortRefresh({ commit }) {
      commit('setSortStatus', {
        id: 0,
        name: "Все статусы"
      });
      commit('setPriorityStatus', {
        id: 0,
        name: "Все приоритеты"
      });
      commit('setSortType', {
        name: 'Все типы',
        value: 0
      });
      commit('setSortDeadline', {
        status: false,
        date: ''
      });
    }
  },
  modules: {
  },
  plugins: [
    createPersistedState({
      paths: ['authTokens', 'user', 'login']
    })
  ]
})
